'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BadgeText = exports.BadgeButton = exports.Badge = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  background-color: ', ';\n  border-radius: ', 'px;\n  border: 1px solid ', ';\n  color: ', ';\n  display: inline-block;\n  font-family: ', ';\n  font-size: ', 'px;\n  height: ', 'px;\n  line-height: ', 'px;\n  margin-top: ', 'px;\n  min-width: ', 'px;\n  outline: none;\n  padding: 0;\n  position: relative;\n  text-decoration: none;\n  white-space: nowrap;\n  ', '\n\n  margin-', ': ', 'px;\n'], ['\n  background-color: ', ';\n  border-radius: ', 'px;\n  border: 1px solid ', ';\n  color: ', ';\n  display: inline-block;\n  font-family: ', ';\n  font-size: ', 'px;\n  height: ', 'px;\n  line-height: ', 'px;\n  margin-top: ', 'px;\n  min-width: ', 'px;\n  outline: none;\n  padding: 0;\n  position: relative;\n  text-decoration: none;\n  white-space: nowrap;\n  ', '\n\n  margin-', ': ', 'px;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  cursor: pointer;\n'], ['\n  cursor: pointer;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  display: inline-block;\n  text-align: center;\n  min-width: ', 'px;\n  padding: 0 ', ';\n  line-height: ', 'px;\n'], ['\n  display: inline-block;\n  text-align: center;\n  min-width: ', 'px;\n  padding: 0 ', ';\n  line-height: ', 'px;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _helpers = require('../../helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var height = function height(size) {
  return Math.round(size * 1.785);
};

var Badge = exports.Badge = _styledComponents2.default.div(_templateObject, function (props) {
  return props.theme.color[props.variant];
}, function (props) {
  return height(props.size) / 2 + 1;
}, function (props) {
  return props.theme.color[props.variant];
}, function (props) {
  return props.theme.color[props.textColor];
}, function (props) {
  return props.bold ? props.theme.font.bold : props.theme.font.default;
}, function (props) {
  return props.size;
}, function (props) {
  return height(props.size);
}, function (props) {
  return height(props.size);
}, function (props) {
  return props.top;
}, function (props) {
  return props.minWidth || 0;
}, (0, _helpers.boolStyle)('outline', 'background-color: #ffffff; color: #707070; border-color: #e6e6e6;'), function (props) {
  return props.align === 'left' ? 'right' : 'left';
}, function (props) {
  return height(props.size) / 2;
});

Badge.displayName = 'Badge';
var BadgeButton = exports.BadgeButton = Badge.withComponent('button').extend(_templateObject2);

var BadgeText = exports.BadgeText = _styledComponents2.default.div(_templateObject3, function (props) {
  return height(props.size) - 2;
}, function (props) {
  return props.icon && props.label ? '8px' : '4px';
}, function (props) {
  return height(props.size) - 2;
});
BadgeText.displayName = 'BadgeText';


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-badge/styles.js
// module id = 2886
// module chunks = 4